//@flow
import React from 'react';
import type { ComponentType } from 'react';
import { themr } from 'react-css-themr';
import { CardTab } from './CustomTabs';
import { EnhancedCardTabs } from './EnhancedTabs';
import theme from './NavTabs.scss';
import type { TFunction } from 'react-i18next';

type NavTab = {
    title: string,
    tabId?: string,
    path: string,
    query?: { [string]: string },
    isVisible: boolean,
    rightComponent?: ComponentType<any> // Use for alerts icon
};

type Props = {
    activeTabId?: string,
    activeTabIndex?: number,
    tabs: Array<NavTab>,
    handleTabChange: number => void,
    theme: { +[key: ?string]: string },
    t: TFunction
};

const NavTabs = (props: Props) => {
    const {
        activeTabId,
        activeTabIndex,
        tabs,
        handleTabChange,
        t,
        theme
    } = props;
    return (
        <EnhancedCardTabs
            theme={theme}
            activeTabId={activeTabId}
            activeTabIndex={activeTabIndex}
            onChange={handleTabChange}
        >
            {tabs.map(tab => {
                const { title, rightComponent, tabId } = tab;
                return (
                    <CardTab
                        theme={theme}
                        key={title}
                        tabId={tabId}
                        label={t(title)}
                        rightComponent={rightComponent}
                    />
                );
            })}
        </EnhancedCardTabs>
    );
};

export default themr('ThemedNavTabs', theme)(NavTabs);
